/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { IntegrationMetadata } from '../models/IntegrationMetadata';
import type { TenantDiscovery } from '../models/TenantDiscovery';
import type { TenantDiscoveryResponse } from '../models/TenantDiscoveryResponse';
import type { TenantSPInformation } from '../models/TenantSPInformation';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class SsoService {
  /**
   * Discover tenant based on user email. If tenant is not found, suggest standard password login as next step and login_url is null.
   * @param data
   * @returns TenantDiscoveryResponse
   * @throws ApiError
   */
  public static apiSsoDiscoverCreate(data: TenantDiscovery): CancelablePromise<TenantDiscoveryResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/sso/discover',
      body: data,
    });
  }
  /**
   * Read metadata URL for SSO integration.
   * @param data
   * @returns IntegrationMetadata
   * @throws ApiError
   */
  public static apiSsoIntegrationsMetadataCreate(data: IntegrationMetadata): CancelablePromise<IntegrationMetadata> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/sso/integrations/metadata',
      body: data,
    });
  }
  /**
   * Initiate SSO login for a specific tenant.
   * @returns any
   * @throws ApiError
   */
  public static apiSsoLoginCreate(): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/sso/login',
      errors: {
        302: `Redirect to IdP SSO URL`,
      },
    });
  }
  /**
   * @param firmId
   * @returns TenantSPInformation
   * @throws ApiError
   */
  public static apiSsoTenantRead(firmId: string): CancelablePromise<TenantSPInformation> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/sso/tenant/{firm_id}',
      path: {
        firm_id: firmId,
      },
    });
  }
}
